var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 12,
    viewBox: "0 0 236 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.667 6C224.667 8.94552 227.054 11.3333 230 11.3333C232.946 11.3333 235.333 8.94552 235.333 6C235.333 3.05448 232.946 0.666667 230 0.666667C227.054 0.666667 224.667 3.05448 224.667 6ZM0 7H230V5H0V7Z",
    fill: "#095E4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon2);
export default __webpack_public_path__ + "static/media/line-icon2.c199f8b2131ac2bb515669bbeef930b3.svg";
export { ForwardRef as ReactComponent };